<template>
  <div class="container lang-dir">
    <PersonalAreaNavBar
      backurl="personal-area-mainmenu"
      :title="$t('personalArea.disktoonline.title')"
    />
    <div style="padding: 15px">
      <div class="flex" style="flex-direction: column; gap: 15px">
        <div class="questions">
          {{ $t("personalArea.disktoonline.m1") }}<br />
          {{ $t("personalArea.disktoonline.m2") }}<br />
          {{ $t("personalArea.disktoonline.m3") }}<br />
          {{ $t("personalArea.disktoonline.m4") }}<br />
        </div>
        <div class="answer-yes msg">
          {{ $t("personalArea.disktoonline.m5") }}
        </div>
        <div class="spliter"></div>
        <div style="padding: 15px 0px; overflow-x: hidden">
          <b
            ><p>
              {{ $t("personalArea.disktoonline.m6") }}
            </p></b
          >
          <p>
            {{ $t("personalArea.disktoonline.m7") }}
          </p>
        </div>
        <div class="cost-year">
          <p class="tiny-bold-title">
            {{ $t("personalArea.disktoonline.m8") }}
          </p>
          <p>
            <b>{{ $t("personalArea.disktoonline.m9") }}</b>
            {{ $t("personalArea.disktoonline.m10") }}
          </p>
        </div>
        <div>
          <p class="tiny-bold-title">
            {{ $t("personalArea.disktoonline.m11") }}
          </p>
          <ol style="list-style-type: inherit; padding: 10px 25px">
            <li>
              {{ $t("personalArea.disktoonline.m12") }}
            </li>
            <li>
              {{ $t("personalArea.disktoonline.m13") }}
            </li>
            <li>
              {{ $t("personalArea.disktoonline.m14") }}
            </li>
          </ol>
        </div>
        <div class="cost-year">
          <p>
            {{ $t("personalArea.disktoonline.m15") }}
          </p>
        </div>
        <div>
          <p>{{ $t("personalArea.disktoonline.m16") }}</p>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-around;
            flex-direction: row;
            align-items: center;
          "
        >
          <label @click.stop="openPdf('info.pdf')" style="color: #a7610f">{{
            $t("personalArea.disktoonline.agree")
          }}</label>
          <button @click.stop="openPdf('sign.pdf')" class="btn btn-larg">
            {{ $t("personalArea.disktoonline.downloadAgree") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonalAreaNavBar from "./PersonalAreaNavBar.vue";
import path from "path";
export default {
  components: { PersonalAreaNavBar },
  methods: {
    openPdf(src) {
      if (this.$store.state.hasInternet) {
        src = path.join("https://otzar.org/disktoonline", src);
        openHref(src);
      } else {
        let shortUrl = globalThis.APP_URL_SHORT || "";
        src = path.join(shortUrl, "disktoonline", src);
        window.open(src);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.questions {
}
.tiny-bold-title {
  color: #7b7b7b;
  font-size: 11px;
  font-weight: 700;
}
.answer-yes {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
.cost-year {
  border-radius: 5px;
  background: #ebebeb;
  padding: 10px;
}
.msg {
  color: #a7610f;
  font-weight: 700;
}
.spliter {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
}
.container {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  padding-bottom: 15px;
  overflow-x: hidden;
}
.container * {
  margin: 0px;
}
</style>
